<template>
<div class="publicNumber accountInfo padding-20 bgc box-shadow">
    <router-view></router-view>
</div>
</template>

<script>
export default {
    name: 'publicNumber',
    data() {
        return {}
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">

</style>
